import { StyleSheet } from "react-native";
import { themeRoundnessMultiplier } from "../../constants";
import { useAppTheme } from "../../useAppTheme";
import Box from "../Box";
import { LeaderboardXpAmount } from "./LeaderboardXpAmount";

type Props = {
	value: number;
	highlighted?: boolean;
};

export const LeaderboardMetricPill = ({
	value,
	highlighted = false,
}: Props) => {
	const theme = useAppTheme();

	return (
		<Box
			paddingHorizontal={8}
			paddingVertical={6}
			borderRadius={theme.roundness * themeRoundnessMultiplier}
			backgroundColor={
				highlighted
					? theme.colors.elevation.level5
					: theme.colors.elevation.level1
			}
		>
			<LeaderboardXpAmount
				value={value}
				numberVariant="bodyMedium"
				numberStyle={[styles.number, { color: theme.colors.onSurface }]}
				unitVariant="labelSmall"
				unitStyle={{ color: theme.colors.onSurfaceVariant }}
			/>
		</Box>
	);
};

const styles = StyleSheet.create({
	number: {
		fontWeight: "600",
	},
});
